import React from "react";


// navbar component

export default function Navbar(){

    return(
        <div className="navbar">
            <div className="nav-logo">
            <img src="https://img.icons8.com/bubbles/50/000000/bbb.png" alt="nav-logo"/>
            </div>
            <div>
                <h3>React DropDown</h3>
            </div>

        </div>

    )


}


// WEBPACK FOOTER //
// ./src/components/Navbar.js